import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

// Confirmed against the shipping mobile app's API client (2026-10-22): the
// GET wraps filters as params: { data: {...} }, but the POST (apply) sends
// plain multipart FormData, NOT wrapped — the two aren't symmetric.
export const getLeaves = async (params) => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.LEAVE.GET, { params: { data: params } });
  return response;
};

export const applyLeave = async (formData) => {
  const response = await studentApi.post(STUDENT_ENDPOINTS.LEAVE.APPLY, formData);
  return response;
};
